import React from 'react';
import PropTypes from 'prop-types';
import { StyledTag } from './styles';

const Tag = ({ color, position, children, ...props }) => (
  <StyledTag tagColor={color} position={position} {...props}>
    {children}
  </StyledTag>
);

Tag.propTypes = {
  /**
   * Sets left/right margins depending on the position of the badge.
   */
  position: PropTypes.oneOf(['right', 'left']),
  /**
   * Sets the tag's background color.
   */
  color: PropTypes.oneOf([
    'gray',
    'purple',
    'orange',
    'pink',
    'teal',
    'green',
    'turquoise',
    'yellow',
    'violet',
    'dark-pink',
    'beta',
    'new',
  ]),
};

Tag.defaultProps = {
  position: 'right',
  color: 'pink',
};

export default Tag;
